import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FoodPlaceholder from '../../../assets/images/food-placeholder.jpg';
import { LessonPlan } from '../../../types/lessonPlan.type';
import { getPrimaryRecipe, getRecipeImage } from '../../../utils/utils';
import './RecipeCard.css';

interface LessonPlanCardProps {
    lessonPlan: LessonPlan;
}

const LessonPlanCard: React.FC<LessonPlanCardProps> = ({ lessonPlan }) => {
    let recipeImage: string = FoodPlaceholder;
    const primary = getPrimaryRecipe(lessonPlan);
    if (primary) {
        recipeImage = getRecipeImage(primary, 'card') ?? FoodPlaceholder;
    }

    return (
        <Card className="recipe-card" style={{ width: '100%' }}>
            <Card.Img
                variant="top"
                src={recipeImage}
                onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    if (target.src !== FoodPlaceholder) {
                        target.src = FoodPlaceholder;
                    }
                }}
            />
            <Card.Body className="recipe-details">
                <div className="recipe-information">
                    <Card.Subtitle className="subheader text-uppercase">
                        Family Meal Plan
                    </Card.Subtitle>
                    <Card.Title className="recipe-card-title">
                        <Link to={`/lesson-plans/${lessonPlan.slug ?? lessonPlan.id}`}>
                            {lessonPlan.name}
                        </Link>
                    </Card.Title>
                </div>
            </Card.Body>
        </Card>
    );
};

export default LessonPlanCard;